module.exports = __webpack_public_path__ + "static/media/17.266ac43e.jpg";